import React from 'react';
import styled from 'styled-components';

import CardHeader from 'components/CardHeader';
import ChartInputs from 'modules/Prices/pages/compare/components/Header/ChartInputs';
import ExportButton from 'components/Export';

import { I18n } from 'react-redux-i18n';
import { components } from 'apiTyped/types';
import { Option } from 'interface';
import { useUserMe } from '../../../../../../apiTyped/hooks/users.query';
import get from 'lodash/get';

const HeaderRight = styled.div`
  display: flex;
  .row {
    margin-right: 20px;
  }
`;

const PricesCompareHeader = ({
  data,
  exportName,
  setVintageEnd,
  setVintageStart
}: {
  data: components['schemas']['DataDetail'][];
  exportName: string | null;
  // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
  setVintageEnd: (e: any) => void;
  // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
  setVintageStart: (e: any) => void;
}) => {
  const { user } = useUserMe(true);
  const clientTags = get(user, 'client.tags', []);

  const vintageOptions =
    data && data.length > 0
      ? [...new Set(data.map((item) => item.vintage))]
          .filter((item) => !isNaN(Number(item)))
          .sort()
          .reverse()
          .map((item) => ({ value: item, label: item }))
      : [];

  const onChange = (field: string, value: Option) => {
    const mapping = {
      vintageStart: setVintageStart,
      vintageEnd: setVintageEnd
    };
    // @ts-expect-error, mapping dynamics
    mapping[field](value.value);
  };

  return (
    <CardHeader
      title={I18n.t('prices.compare.title')}
      fontSize="20px"
      rightComponents={
        <HeaderRight>
          {
            // @ts-expect-error weird
            !clientTags.includes('Champagne') && (
              <ChartInputs
                vintageOptions={vintageOptions}
                onChange={onChange}
              />
            )
          }
          <ExportButton
            jpg
            pdf
            targetElement="#prices-compare"
            name={`${exportName} - ${I18n.t('prices.compare.title')}`}
          />
        </HeaderRight>
      }
    />
  );
};

export default PricesCompareHeader;
